import getLocationDropdownResultData from './getLocationDropdownResultData';
import resolveSelectedLocation from '../actions/resolveSelectedLocation';
import FindLocationResultState from '../data/schema/FindLocationResultState';
import { trace } from 'owa-trace';

export default function addHighlightedFindLocations(
    disableUseThisLocation: boolean,
    findLocationResultState: FindLocationResultState
) {
    let resultData = getLocationDropdownResultData(disableUseThisLocation, findLocationResultState);
    let locationToAdd;

    if (
        findLocationResultState.findResultHightlightIndex < 0 ||
        findLocationResultState.findResultHightlightIndex >=
            resultData.findResultsCount + resultData.findResultOffset
    ) {
        trace.error('Invalid hightlighted location Index');
    } else if (findLocationResultState.findResultHightlightIndex < resultData.findResultOffset) {
        // If usethislocation is highlited use the query string
        locationToAdd = findLocationResultState.queryString;
    } else {
        let findLocationIndex =
            findLocationResultState.findResultHightlightIndex - resultData.findResultOffset;
        locationToAdd = findLocationResultState.findResultSet[findLocationIndex];
    }

    if (locationToAdd) {
        resolveSelectedLocation(findLocationResultState, locationToAdd);
    }
}
